module.exports = __webpack_public_path__ + "assets/media/vokrug-2.67e69e1c.svg";